import { z } from 'zod';

/**
 * Pagination, une seule fois pour tout le produit.
 *
 * Ces deux briques vivaient dans `_billing-fields.ts`, où la facturation les avait écrites en
 * premier ; elles n'ont rien de comptable. La console de plateforme a eu besoin des mêmes, et il
 * valait mieux les sortir que d'en avoir deux définitions qui finiraient par diverger sur le
 * plafond ou sur le nom du champ.
 *
 * Le plafond de cent existe pour que personne ne demande la base entière en une requête : une
 * `pageSize` non bornée est la façon ordinaire de transformer une liste en déni de service.
 */

export const paginationFields = {
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(100).default(20),
};

/** Enveloppe de liste paginée. `total` est le nombre de lignes correspondantes, pas celui de la page. */
export interface PaginatedDto<T> {
  items: T[];
  page: number;
  pageSize: number;
  total: number;
}
